import script from "./PropertyScope.vue?vue&type=script&setup=true&lang=js"
export * from "./PropertyScope.vue?vue&type=script&setup=true&lang=js"

import "./PropertyScope.vue?vue&type=style&index=0&id=35751712&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35751712"]])

export default __exports__